import Link from "next/link";
import Skeleton from "react-loading-skeleton";
import S from "../index.module.scss";

const ActualCardLoading = () => {
  return (
    <Link className={S.newsItem} href={"#"}>
      <div className={S.imageWrapper}>
        <Skeleton className={S.newsImageSkeleton} />
      </div>
      <div className={S.newsInfo}>
        <Skeleton className={S.titleSkeleton} height={20} />
        <Skeleton className={S.dateSkeleton} />
      </div>
    </Link>
  );
};

export default ActualCardLoading;
